<template>
    <div>
        <loading :active.sync="isLoading"
                 :is-full-page="fullPage"
                 color="#00F">
        </loading>

        <b-button v-if="proposal_status == 2" class="mt-2" variant="success" block v-on:click="confirmProposal()">
            Confirm Proposal Data
        </b-button>
        <b-button v-if="proposal_status == 5" class="mt-2" variant="success" block v-on:click="completeProposal()">
            Complete Proposal
        </b-button>
        <b-button v-if="proposal_status == 5" class="mt-3" variant="danger" block v-on:click="rejectByCustomer()">
            Reject
        </b-button>
        <b-button v-if="proposal_status == 2" class="mt-2" variant="primary" block v-on:click="transferToAgent()">
            Transfer To Agent
        </b-button>

    </div>
</template>

<script>
    import {mapState, mapActions} from "vuex";

    export default {
        data: () => {
            return {
                isLoading: false,
                fullPage: true
            };
        },
        computed: {
            ...mapState("proposal", ["ActionData", "proposal_id", "is_signature_step", "proposal_status" , "CustomerData"])
        },
        mounted() {

        },
        methods: {
            ...mapActions("proposal", [
                "customerRejectProposal",
                "customerConfirmProposal",
                "proposalTransferToAgent",
                "customerCompleteProposal",
                "validateFinal"
            ]),
            agreeOk() {
                this.$bvModal.hide("modal-proposal-agree");
                this.$set(this.ActionData, "summary_confirm", true);
            },
            rejectByCustomer() {
                this.isLoading = true;
                let data = {
                    proposal_id: this.proposal_id
                };
                this.customerRejectProposal(data).then((response) => {
                    if (!response.data.errors) {
                        this.$snotify
                            .success(response.data.message, "", {
                                position: "centerTop",
                            }).on("destroyed", () => {
                            this.$router.push({
                                name: "ProposalListCustomer",
                                query: {
                                    uuid: this.$route.query.uuid
                                }
                            })
                        });
                    }else{
                      this.$snotify
                          .error(response.data.errors.message, "", {
                            position: "centerTop",
                          });
                    }
                    this.isLoading = false;
                });
            },
            completeProposal() {
                if(!this.CustomerData.signature){
                    this.$snotify
                        .error("Please put your signature to proceed", "", {
                            position: "centerTop",
                        });

                }else{
                    this.isLoading = true;

                    this.validateFinal().then((response) => {
                        if (response.data.errors) {
                            this.isLoading = false;
                            this.$snotify
                                .error(response.data.errors.message, "", {
                                    position: "centerTop",
                                });

                        } else {
                            let data = {
                                proposal_id: this.proposal_id,
                                signature:this.CustomerData.signature
                            };
                            this.customerCompleteProposal(data).then((response) => {
                                if (!response.data.errors) {
                                    this.$snotify
                                        .success(response.data.message, "", {
                                            position: "centerTop",
                                        }).on("destroyed", () => {
                                        this.$router.push({
                                            name: "ProposalListCustomer",
                                            query: {
                                                uuid: this.$route.query.uuid
                                            }
                                        })
                                    });
                                }else{
                                  this.$snotify
                                      .error(response.data.errors.message, "", {
                                        position: "centerTop",
                                      });
                                }
                                this.isLoading = false;
                            });
                        }
                    });

                }

            },
            confirmProposal() {
                this.isLoading = true;

                this.validateFinal().then((response) => {
                    if (response.data.errors) {
                        this.isLoading = false;
                        this.$snotify
                            .error(response.data.errors.message, "", {
                                position: "centerTop",
                            });

                    } else {
                        let data = {
                            proposal_id: this.proposal_id
                        };
                        this.customerConfirmProposal(data).then((response) => {
                            if (!response.data.errors) {
                                this.$snotify
                                    .success(response.data.message, "", {
                                        position: "centerTop",
                                    }).on("destroyed", () => {
                                    this.$router.push({
                                        name: "ProposalListCustomer",
                                        query: {
                                            uuid: this.$route.query.uuid
                                        }
                                    })
                                });
                            }else{
                              this.$snotify
                                  .error(response.data.errors.message, "", {
                                    position: "centerTop",
                                  });
                            }
                            this.isLoading = false;
                        });
                    }
                });
            },
            transferToAgent() {
                this.isLoading = true;
                let data = {
                    proposal_id: this.proposal_id
                };
                this.proposalTransferToAgent(data).then((response) => {
                    if (!response.data.errors) {
                        this.$snotify
                            .success(response.data.message, "", {
                                position: "centerTop",
                            }).on("destroyed", () => {
                            this.$router.push({
                                name: "ProposalListCustomer",
                                query: {
                                    uuid: this.$route.query.uuid
                                }
                            })
                        });
                    }else{
                      this.$snotify
                          .error(response.data.errors.message, "", {
                            position: "centerTop",
                          });
                    }
                    this.isLoading = false;
                });
            }
        }
    }
</script>

<style scoped>


</style>